import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styled } from '@mui/system';

// Wrapper sekcji z patternem
const SectionWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.primary.main,
  paddingTop: '100px',
  paddingBottom: '100px',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: 'url(/pattern.svg)',
    backgroundRepeat: 'repeat',
    backgroundSize: 'contain',
    opacity: 0.1,
    zIndex: 0,
  },
}));

// Nagłówek z czerwonym podkreśleniem
const UnderlinedHeading = styled('span')({
  position: 'relative',
  zIndex: 1,
  display: 'inline-block',
  '&::after': {
      content: '""',
      position: 'absolute',
      zIndex: "-1",
      right: 0,
      bottom: 0,
      width: '30%',
      height: '30px',
      backgroundImage: 'url(/img/redunderline.svg)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'bottom center',
  },
});


const Section6 = () => (
  <SectionWrapper component="section">
    <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: '28px', md: '54px' },
          fontWeight: 'bold',
          color: 'white',
          mb: '50px',
        }}
      >
        <UnderlinedHeading>Przyspiesz swoją pracę</UnderlinedHeading>
      </Typography>

      <Typography
        variant="body1"
        sx={{
          fontSize: '18px',
          fontWeight: 400,
          color: 'white',
          maxWidth: '800px',
          mx: 'auto',
          mb: 6,
        }}
      >
Zautomatyzuj powtarzalne obrysowywanie PDFów, a linijkę i kalkulator schowaj do szuflady.      
 <br />

  Zyskaj czas na wartościowe czynności i podnieś efektywność z aplikacją Bimetria.
  </Typography>
      <Button
        component="a"
        href="https://app.bimetria.com"
        target="_blank"
        variant="contained"
        endIcon={<ChevronRightIcon />}
        sx={{
          backgroundColor: 'turquoise.main',
          color: 'white',
          textTransform: 'none',
          fontWeight: 500,
            
                fontSize: { xs: '16px', md: '18px' },
                px: { xs: 3, md: 4 },
                py: { xs: 1.5, md: 2 },
        }}
      >
        Wypróbuj za darmo
      </Button>
    </Container>
  </SectionWrapper>
);

export default Section6;
